import {useEffect} from "react";
import * as React from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useBoundStore} from "../../../Store/store";
import {BaseCard} from "../../../Components/Cards/BaseCard";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import dayjs from "dayjs";
import {NumberInput} from "../../../Components/Form/NumberInput";
import {PrimaryButton} from "../../../Components/Buttons/PrimaryButton";
import {useTranslation} from "react-i18next";
import {DangerButton} from "../../../Components/Buttons/DangerButton";
import {TextInput} from "../../../Components/Form/TextInput";
import {SelectInput} from "../../../Components/Form/SelectInput";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft, faDownload} from "@fortawesome/free-solid-svg-icons";
import {ShiftsTable} from "../../../Components/Tables/TableCards/ShiftsTable";
import {ContractsTable} from "../../../Components/Tables/TableCards/ContractsTable";
import {InvoicesTable} from "../../../Components/Tables/TableCards/InvoicesTable";
import {PerformanceReportsTable} from "../../../Components/Tables/TableCards/PerformanceReportsTable";
import {BlackButton} from "../../../Components/Buttons/BlackButton";
import axios from "axios";


export const AdminContractDetail = () => {
    const {
        id,
    } = useParams();
    const navigate = useNavigate();
    const {t} = useTranslation();

    const getContractDetail = useBoundStore((state) => state.getContractDetail);
    const contractDetail = useBoundStore((state) => state.contractDetail);

    useEffect(() => {
        getContractDetail(id);
    }, [getContractDetail, id]);

    const DownloadLink = ({ url, fileName }) => {
        const handleDownload = () => {
            fetch(url)
                .then((response) => response.blob())
                .then((blob) => {
                    const url = window.URL.createObjectURL(new Blob([blob]));
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = fileName || "downloaded-file";
                    document.body.appendChild(link);

                    link.click();

                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.error("Error fetching the file:", error);
                });
        };

        return (
            <div>
                <BlackButton type="primary" onClick={handleDownload}>
                    <FontAwesomeIcon className="group-hover:text-primary" icon={faDownload}/>
                </BlackButton>
            </div>
        );
    };

    return (
        <div>
            <div>
                <div className={'flex flex-row justify-between mb-4 items-center'}>
                    <div>
                        <h1 className={'text-2xl font-semibold'}>Contract details</h1>
                        <div className={"flex flex-row group items-center gap-2"} onClick={() => {
                            navigate(-1);
                        }}>
                            <FontAwesomeIcon icon={faArrowLeft} className={'text-sm transition-all group-hover:mr-2 duration-500 cursor-pointer'}/>
                            <div className={'text-sm text-gray-500 my-auto cursor-pointer'}>{t('general.actions.back_to_overview')}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={'grid grid-cols-1 md:grid-cols-3 md:space-x-4 space-y-4 md:space-y-0'}>
                <div className={'md:col-span-3 space-y-4'}>
                    <BaseCard border={false}>
                        <div className={'flex flex-wrap justify-between mb-4'}>
                            <h1 className={'text-lg font-semibold'}>Document</h1>
                            {
                                contractDetail?.document !== null && contractDetail?.document !== undefined && (
                                    <DownloadLink
                                        url={contractDetail?.document?.url}
                                        fileName={contractDetail?.document?.name}
                                    />
                                )
                            }
                        </div>

                        {
                            contractDetail?.document !== null && contractDetail?.document !== undefined && contractDetail?.document.hasOwnProperty('url') && (
                                <iframe src={contractDetail?.document?.url} width="100%" height="600px" />
                            )
                        }
                    </BaseCard>
                </div>
            </div>
        </div>
    )
}